import styled from 'styled-components'

export const PageLoading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  height: 54px;
  width: 54px;
  transform: translate(-50%, -50%);
  padding: 15px;
  border-radius: 50px;
  background-color: rgba(150, 150, 150, 0.05);
  box-sizing: border-box;
`
